import { RavioliCommonContent } from "../RavioliCommonContent/RavioliCommonContent";
import { RavioliMedia } from "../RavioliMedia/RavioliMedia";
import type { IHeroSplitImageProps } from "./HeroSplitImage.props";

export const HeroSplitImage = ({
  alignment,
  buttons,
  description,
  eyebrow,
  heading,
  image,
}: IHeroSplitImageProps) => {
  const hasContent = Boolean(eyebrow || heading || description || buttons?.length);
  const media = (
    <RavioliMedia
      aspectRatio={image.aspectRatio || "16:9"}
      className={
        hasContent
          ? "ravioli-motion-travel h-full min-h-80 min-w-0 w-full md:order-2"
          : "ravioli-motion-travel w-full"
      }
      imageClassName="h-full object-cover transition-transform duration-200 ease-out hover:scale-[1.015]"
      media={image.image}
      priority
      sizes={hasContent ? "(min-width: 768px) 55vw, 100vw" : "100vw"}
    />
  );

  if (!hasContent) return media;

  return (
    <div className="grid min-w-0 overflow-hidden border border-primary bg-surface md:min-h-[42rem] md:grid-cols-[5fr_7fr]">
      {media}
      <RavioliCommonContent
        alignment={alignment}
        buttons={buttons}
        className="min-w-0 justify-center bg-collection p-7 md:order-1 md:p-10 lg:p-12"
        description={description}
        eyebrow={eyebrow}
        heading={heading}
        headingAs="h1"
        headingClassName="max-w-[11ch] text-5xl leading-[0.96] md:text-[5rem] md:leading-[4.75rem]"
      />
    </div>
  );
};

HeroSplitImage.displayName = "Content::HeroSplitImage";
